import {
  AssetExportConfiguration,
  CreateAssetExportConfigurationInput,
  DeleteAssetExportConfigurationInput,
  UpdateAssetExportConfigurationInput,
} from '../types/asset_export_configuration';
import { ExportFile } from '../types/export/export';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const EXPORT = '/api/asset/export';
const CONFIGURATIONS = '/api/asset/export/list';
const CREATE_CONFIGURATION = '/api/asset/export/create';
const UPDATE_CONFIGURATION = '/api/asset/export/update';
const DELETE_CONFIGURATION = '/api/asset/export/delete';

export namespace AssetExportConfigurationRequest {
  export interface AssetExportPayload {
    configId?: string;
    timezone?: string;
    locale?: string;
  }

  export const download = async (payload: AssetExportPayload): Promise<ExportFile> => {
    return (await http.post(EXPORT, payload)).data;
  };

  export const list = async (payload: { page: number }): Promise<PaginatedResponse<AssetExportConfiguration>> => {
    return (await http.post(CONFIGURATIONS, payload)).data;
  };

  export const create = async (payload: {
    data: CreateAssetExportConfigurationInput[];
  }): Promise<AssetExportConfiguration[]> => {
    return (await http.post(CREATE_CONFIGURATION, payload)).data;
  };

  export const update = async (payload: {
    data: UpdateAssetExportConfigurationInput[];
  }): Promise<AssetExportConfiguration[]> => {
    return (await http.post(UPDATE_CONFIGURATION, payload)).data;
  };

  export const remove = async (payload: {
    data: DeleteAssetExportConfigurationInput[];
  }): Promise<AssetExportConfiguration[]> => {
    return (await http.post(DELETE_CONFIGURATION, payload)).data;
  };
}
